import React from "react";
import { useTranslation } from "react-i18next";
import { HashLoader  } from "react-spinners";
export default function LoadingSpinner({size}) {
  const {t}=useTranslation();
  return (
    <div className="fixed inset-0 flex items-center justify-center text-theme-headerBg "style={{
        backgroundColor: "transparent",   
      }}>
      <div className="text-center">
    
        <HashLoader
  color='#be8024'
  size={size}
/>
      </div><br/>
    </div>
  );
}